import { render } from "./TheWorkspace.vue?vue&type=template&id=6dc587c1"
import script from "./TheWorkspace.vue?vue&type=script&lang=js"
export * from "./TheWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__